<!-- Forgot password-->

<div class="fullscreen">
    <div class="row justify-content-center m-0 auth-box">
        <div class="col-sm-6 p-0" *ngIf="!loading">
      
            <!-- Error message -->
            <mat-card class="p-0" *ngIf="error">
                <div class="primary-bg flex-display">                  
                    <h3 translate class="align-text-center auth-header">GENERIC.ERROR</h3>
                </div>
                <mat-card-content class="p-4 text-center">
                    <fa-icon icon="times-circle" size="4x" class="text-danger"></fa-icon> 
                    <div>{{ error.message }}</div>
                </mat-card-content>
            </mat-card>
    
            <form #loginForm="ngForm" (ngSubmit)="resetPass()"  *ngIf="user">
            <mat-card class="p-0">
                <div class="primary-bg flex-display">  
                     <!-- Forgot password? heading -->
                    <h3 translate class="align-text-center auth-header">SIGNIN.FORGOT</h3>
                </div>

                <!-- 'Resetting password for {{ name }}'' message -->
                <mat-card-content class="p-4">
                    <div>{{ 'SIGNIN.FORGOT_DO' | translate: user }}</div>
                    
                    <!-- Password -->
                    <mat-form-field class="w-100">
                        <mat-icon matPrefix class="mr-2">lock</mat-icon>
                        <input matInput type="password" name="pass1" placeholder="{{'SIGNIN.PASS' | translate }}" [(ngModel)]="user.pass" required >
                        <mat-hint>{{ 'SIGNIN.PASSWORD_LENGTH' | translate }}</mat-hint>
                    </mat-form-field>

                     <!-- Confirm password -->
                    <mat-form-field class="w-100">
                        <mat-icon matPrefix class="mr-2">lock</mat-icon>
                        <input matInput type="password" name="pass21" placeholder="{{'SIGNIN.PASS_CONFIRMATION' | translate }}" [(ngModel)]="pass2" required >
                        <mat-hint>{{ 'SIGNIN.PASSWORD_CONFIRM' | translate }}</mat-hint>
                    </mat-form-field>
                </mat-card-content>
                
                 <!-- Submit button -->
                <mat-card-actions class="m-0 p-4">
                    <button mat-raised-button color="primary" type="submit" class="w-100 m-0" [disabled]="pass2 != user.pass || !user.pass.length">{{ 'GENERIC.SUBMIT' | translate }}</button>
                </mat-card-actions>
            </mat-card>
            </form>
        </div>
    </div>

</div>
<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>